export default {
  spendField: 'spend_ltd',
  interpolateMonths: true,
  trendMetrics: [
    {
      metric: 1,
      field: 'adpi',
      label: 'Ad Effect Score',
      format: '.0f',
      scale: [125, 185]
    },
    {
      metric: 13,
      field: 'recall',
      label: 'Branded Recall with Spend',
      format: '.0%',
      hasSpendData: true,
      scale: [0, 0.8]
    },
    {
      metric: 4,
      field: 'consideration',
      label: 'Lift to Consideration',
      format: '.0%',
      scale: [0, 0.8]
    },
    {
      metric: 5,
      field: 'impression',
      label: 'Lift to Impression',
      format: '.0%',
      scale: [0, 0.8]
    },
    {
      metric: 6,
      field: 'actions',
      label: 'Net Actions',
      format: '.0%',
      scale: [0, 0.8]
    },
  ]
};



// WEBPACK FOOTER //
// ./src/app/configuration/Retail/config/components/scorecard/Trendchart/index.js